import React from 'react';
import { RuleBuilderSuggestionOptionSchema } from '@flybits/webapp-react-rule-builder';
import { FlightTextInput } from '@flybits/design-system';
import { LoadingIcon } from 'components/Shared/LoadingIcon/LoadingIcon';
import { PushFormClassPrefix as CLASS_PREFIX } from 'components/ExperienceCanvas/constants';
import { Content } from 'interface/content/content.interface';

type ContentIdDropdownProps = {
  menuRef: React.RefObject<HTMLDivElement | null>;
  searchVal: string;
  onSearchChange: (value: string) => void;
  contentInstances: RuleBuilderSuggestionOptionSchema[] | undefined;
  isLoading: boolean;
  isFetchingNextPage: boolean;
  isError: boolean;
  errorMessage?: string;
  onSelectContentId: (contentId: string, contentName?: string) => void;
  setLastOptionElement: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
};

const ContentIdDropdown = ({
  menuRef,
  searchVal,
  onSearchChange,
  contentInstances,
  isLoading,
  isFetchingNextPage,
  isError,
  errorMessage,
  onSelectContentId,
  setLastOptionElement,
}: ContentIdDropdownProps) => (
  <div
    ref={menuRef}
    className={`${CLASS_PREFIX}__actionlink__content-id-dropdown__menu ${CLASS_PREFIX}__actionlink__content-id-dropdown__menu--above`}
  >
    <div className={`${CLASS_PREFIX}__actionlink__content-id-dropdown__panel`}>
      <FlightTextInput
        value={searchVal}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)}
        width="100%"
        iconInput="search"
        hasClearIcon
        placeholderText="Search content"
        aria-label="Search content instances"
      />
      {(isLoading || isFetchingNextPage) && (
        <div className={`${CLASS_PREFIX}__actionlink__content-id-dropdown__loading`}>
          <LoadingIcon />
        </div>
      )}
      {isError && (
        <div className={`${CLASS_PREFIX}__actionlink__field__item--header`}>
          {errorMessage || 'Could not load content instances'}
        </div>
      )}
      {!isLoading &&
        !isError &&
        contentInstances?.map((option, index) => {
          const content = option.payload as Content;
          const contentId = content.id ?? '';
          const isLastOption = index === contentInstances.length - 1;

          return (
            <button
              key={contentId || `content-option-${index}`}
              ref={isLastOption ? setLastOptionElement : undefined}
              type="button"
              className={`${CLASS_PREFIX}__actionlink__field__item ${CLASS_PREFIX}__actionlink__content-id-item`}
              aria-label={`select content ${option.name || contentId}`}
              onClick={() => onSelectContentId(contentId, option.name || contentId)}
            >
              <span className={`${CLASS_PREFIX}__actionlink__content-id-item__name`}>{option.name || contentId}</span>
              {contentId && (
                <span className={`${CLASS_PREFIX}__actionlink__content-id-item__subtext`}>{contentId}</span>
              )}
            </button>
          );
        })}
      {!isLoading && !isError && !contentInstances?.length && (
        <div className={`${CLASS_PREFIX}__actionlink__field__item--header`}>No content instances found</div>
      )}
    </div>
  </div>
);

export default ContentIdDropdown;
